/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return ``
};

const en_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return ``
};

const es_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.departure} - ${i.arrival}`
};

const fr_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return `Covoiturez et économisez !`
};

const it_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return ``
};

const nl_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return ``
};

const pt_routeresults__blablacar_card__title = /** @type {(inputs: { departure: NonNullable<unknown>, arrival: NonNullable<unknown> }) => string} */ (i) => {
	return ``
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.routeresults__blablacar_card__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("routeresults__blablacar_card__title", locale)
	if (locale === "de") return de_routeresults__blablacar_card__title(inputs)
	if (locale === "en") return en_routeresults__blablacar_card__title(inputs)
	if (locale === "es") return es_routeresults__blablacar_card__title(inputs)
	if (locale === "fr") return fr_routeresults__blablacar_card__title(inputs)
	if (locale === "it") return it_routeresults__blablacar_card__title(inputs)
	if (locale === "nl") return nl_routeresults__blablacar_card__title(inputs)
	return pt_routeresults__blablacar_card__title(inputs)
};